var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Icon, StackChildren, Text } from '@doordash/design-language';
import path from 'path-parse';
import * as React from 'react';
import { EnhanceOverlay, ImageContainer, PreviewContainer } from './styles';
import { createImage } from './utils';
var ImagePreview = function (_a) {
    var fileName = _a.fileName, aspect = _a.aspect, imgSrc = _a.imgSrc, croppedArea = _a.croppedArea, isCircleCrop = _a.isCircleCrop, setPhotoResult = _a.setPhotoResult, isLoading = _a.isLoading;
    var _b = React.useState(null), photoPreview = _b[0], setPhotoPreview = _b[1];
    var getCroppedImage = function (image64, pixelCrop) { return __awaiter(void 0, void 0, void 0, function () {
        var image, canvas, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createImage(image64)];
                case 1:
                    image = _a.sent();
                    canvas = document.createElement('canvas');
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    ctx = canvas.getContext('2d');
                    if (ctx) {
                        ctx.fillStyle = 'white';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);
                    }
                    return [2 /*return*/, new Promise(function (resolve) {
                            canvas.toBlob(function (blob) {
                                var fileNameWithExt = fileName;
                                if (!path(fileName).ext) {
                                    fileNameWithExt = "".concat(fileName, ".jpg");
                                }
                                var file = new File([blob], fileNameWithExt || 'fileName.jpg', {
                                    type: 'image/jpeg',
                                });
                                resolve({ file: file, preview: URL.createObjectURL(blob) });
                            }, 'image/jpeg');
                        })];
            }
        });
    }); };
    React.useEffect(function () {
        getCroppedImage(imgSrc, croppedArea).then(function (blob) {
            setPhotoResult(blob.file);
            setPhotoPreview(blob.preview);
        });
    }, []);
    return (React.createElement(PreviewContainer, null,
        photoPreview && (React.createElement(ImageContainer, { src: photoPreview, alt: "cropped-img", isCircleCrop: isCircleCrop, isHorizontalImg: aspect >= 1 ? true : false })),
        photoPreview && isLoading && (React.createElement(EnhanceOverlay, null,
            React.createElement(Text, { textAlign: Text.TextAlignments.Center, color: Text.Colors.SystemWhite },
                React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
                    React.createElement(Icon, { type: Icon.Types.PromoFill, color: Icon.Colors.SystemWhite }),
                    React.createElement("div", null, "Saving and optimizing image...")))))));
};
export default ImagePreview;
